




import { watch, defineComponent, computed } from "@vue/composition-api";
import { pwdFiles} from "@/utils/fileUtils"
import { routerStore } from "@/store/routerStore";
import { infoStore } from "@/store/infoStore";

export default defineComponent({
  setup() {
    const num = computed(() => {
      const fileSet = pwdFiles(infoStore.getState().manifest, routerStore.pwd)
      return fileSet.length;
    });
    return {
      num
    };
  }
});
